<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Categorias de Vídeo</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="categoryVideos">Categorias de Vídeo</label>
                                    <select name="categoryVideos[]" id="categoryVideos" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(categoryVideo, index) in categoryVideos">
                                            {{ categoryVideo.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setCategoryVideos">Ordenar Categorias de Vídeo <i
                                        class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(categoryVideo,index) in selected' :key="categoryVideo.id"
                                        class="list-group-item clearfix">
                                        <i class="mdi mdi-drag pull-left"></i>
                                        <span class="pull-left stages" :id="'stage' + categoryVideo.id">{{ index + 1 }}. {{ categoryVideo.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(categoryVideo, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar
                                </button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação
                                    <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default {
        data: function () {
            return {
                categoryVideos: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getCategoryVideosArray: function (data) {
                let array = [];
                $.each(data, function (index, value) {
                    if (value.sort_by) {
                        array.push(index);
                    }
                });
                return array;
            },
            getCategoryVideos: function () {
                let self = this;
                let api = self.$store.state.api + 'categoryVideo?paginated=false';
                let categoryVideos = $('#categoryVideos');

                self.$http.get(api)
                    .then((response) => {
                        self.categoryVideos = response.data.data;
                        self.ordered = self.getCategoryVideosArray(self.categoryVideos);
                    })
                    .then(() => {
                        categoryVideos.bootstrapDualListbox();
                        categoryVideos.ready(function () {
                            categoryVideos.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Categorias de Vídeo', 'error');
                    });
            },
            setCategoryVideos: function () {
                const self = this;
                let categoryVideos = self.selected;

                $('#categoryVideos').find(':selected').each(function () {
                    categoryVideos.push(self.categoryVideos[$(this).val()]);
                });

                self.selected = categoryVideos;
                self.order = true;
            },
            save: function () {
                const self = this;

                postReorder(self, self.selected, "sort/categoryVideo", self.getCategoryVideosArray);
            },
            remove: function (categoryVideo, index) {
                const self = this;
                const api = self.$store.state.api + 'categoryVideo/' + categoryVideo.id;

                let array = [];
                $.each(self.selected, function (key, value) {
                    if (index !== key) {
                        array.push(value);
                    }
                });

                self.$http
                    .put(api, {
                        sort_by: null
                    })
                    .then((response) => {
                        self.selected = array;
                    });
            },
            back: function () {
                window.location.reload();
            }
        },
        mounted: function () {
            this.getCategoryVideos();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CategoryVideoOrder/Index.vue